var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, } from 'react';
import { FormattedMessage, useIntl, } from 'react-intl';
import { Button, Col, Layout, Pane, PaneFooter, PaneHeader, Row, } from '@folio/stripes/components';
import { TitleManager } from '@folio/stripes/core';
import stripesFinalForm from '@folio/stripes/final-form';
import { FieldSelectionFinal, usePaneFocus, } from '@folio/stripes-acq-components';
import { useOrderTemplates } from '../../hooks';
var ConfigurationOptionsForm = function (props) {
    var form = props.form, handleSubmit = props.handleSubmit, isLoading = props.isLoading;
    var intl = useIntl();
    var paneTitleRef = usePaneFocus().paneTitleRef;
    var _a = form.getState(), pristine = _a.pristine, submitting = _a.submitting;
    var _b = useOrderTemplates(), isOrderTemplatesLoading = _b.isLoading, orderTemplates = _b.orderTemplates;
    var isSubmitDisabled = pristine || submitting;
    var paneTitle = intl.formatMessage({ id: 'ui-mosaic-settings.sections.configuration-options' });
    var renderHeader = useCallback(function (headerProps) { return (React.createElement(PaneHeader, __assign({}, headerProps, { paneTitle: paneTitle }))); }, [paneTitle]);
    var footerEnd = (React.createElement(Row, null,
        React.createElement(Col, { xs: true },
            React.createElement(Button, { buttonStyle: "primary", disabled: isSubmitDisabled, onClick: handleSubmit, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "stripes-acq-components.button.save" })))));
    var dataOptions = useMemo(function () {
        return orderTemplates.map(function (_a) {
            var id = _a.id, templateName = _a.templateName;
            return ({
                label: templateName,
                value: id,
            });
        });
    }, [orderTemplates]);
    return (React.createElement(Pane, { id: "mosaic-configuration-options-settings", defaultWidth: "fill", footer: React.createElement(PaneFooter, { renderEnd: footerEnd }), paneTitleRef: paneTitleRef, renderHeader: renderHeader },
        React.createElement(TitleManager, { record: paneTitle },
            React.createElement(Layout, { className: "padding-bottom-gutter" },
                React.createElement(FormattedMessage, { id: "ui-mosaic-settings.sections.configuration-options.description" })),
            React.createElement("form", { id: "exchange-rate-source-settings-form" },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: true },
                        React.createElement(FieldSelectionFinal, { dataOptions: dataOptions, disabled: isLoading || isOrderTemplatesLoading, fullWidth: true, label: React.createElement(FormattedMessage, { id: "ui-mosaic-settings.sections.configuration-options.field.template" }), name: "defaultTemplateId", required: true })))))));
};
export default stripesFinalForm({
    navigationCheck: true,
    subscription: { values: true },
})(ConfigurationOptionsForm);
